import request from "../request";

export const getHistories = async (
  params: API.PaginationParams & { keyword?: string }
): Promise<API.ListData<API.WorktimeDaily.weekday>> => {
  let url = `/workbenchApi/worktime-daily/histories`
  return await request.get(url, {
    params
  });
};

export const getWorktimeDailyApi = async (date: string, type?: string | null, email?: string | null, isAll?: boolean): Promise<API.WorktimeDaily.dailyInfo> => {
  let url = `/workbenchApi/worktime-daily/${date}`
  return await request.get(url, { params: { type, all: isAll } });
};
export const auditTimeworks = async (date: string, email?: string | null, isAll?: boolean): Promise<{}> => {
  let query = ""
  if (email) {
    query = `?email=${email}`
  }
  if (isAll) {
    query = query ? `${query}&all=true` : `?all=true`
  }
  let url = `/workbenchApi/worktime-daily/${date}/audit-timeworks${query}`
  return await request.patch(url);
};
export const updateTimeworks = async (date: string, email?: string | null): Promise<API.WorktimeDaily.updateDailyInfo> => {
  let url = `/workbenchApi/worktime-daily/${date}/update${email ? `?email=${email}` : ''}`
  return await request.patch(url);
};

// /users/:userID/currentDate/:currentDate
export const getWorktimeDailyDetailApi = async (userID: string, currentDate: string, type?: string): Promise<API.WorktimeDaily.userDailyInfo> => {
  let url = `/workbenchApi/worktime-daily/users/${userID}/currentDate/${currentDate}?type=${type}`
  return await request.get(url);
};

// timeEntries
export const updateTimeEntries = async (params: any): Promise<{}> => {
  let url = `/workbenchApi/worktime-daily/timeEntries`
  return await request.patch(url, params);
};

// audit-info
export const getAuditTypeInfo = async (email?: string | null): Promise<API.WorktimeDaily.auditInfo> => {
  let url = `/workbenchApi/worktime-daily/audit-info`
  if (email) {
    url += `?email=${email}`
  }
  return await request.get(url);
};

// audit-timeworks-sz
export const auditTimeworksSz = async (date: string, email?: string | null, isAll?: boolean): Promise<{}> => {
  
  let query = ""
  if (email) {
    query = `?email=${email}`
  }
  if (isAll) {
    query = query ? `${query}&all=true` : `?all=true`
  }
  let url = `/workbenchApi/worktime-daily/${date}/audit-timeworks-sz${query}`
  return await request.patch(url);
};
interface GetWorktimeDailyNewParams {
    type?: string | null
    email?: string | null
    isAll?: boolean
}
export const getWorktimeDailyNewApi = async (date: string, params: GetWorktimeDailyNewParams): Promise<API.WorktimeDaily.dailyInfoNew> => {
  let url = `/workbenchApi/worktime-daily/new/${date}`
  return await request.get(url, { params: { type: params.type, all: params.isAll } });
};
export const rejectTimeworksApi = async (data: Request.RejectTimeworks): Promise<API.WorktimeDaily.dailyInfoNew> => {
  let url = `/workbenchApi/worktime-daily/reject-timeworks`
  return await request.patch(url, data);
};